import { styled } from 'styled-components';
import { SkapaTokens } from '@inter-ikea-guida/skapa';
export const StyledMain = styled.main `
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;
export const StyledPills = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-bottom: ${SkapaTokens.space150};
  gap: ${SkapaTokens.space100};
`;
export const StyledStorageNeeds = styled.fieldset `
  border: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(${props => props.$columns}, 1fr);
  gap: ${SkapaTokens.space100};
  margin-bottom: ${SkapaTokens.space50};
`;
export const StyledHeading = styled.div `
  > h1 {
    margin-top: 0;
    margin-bottom: ${SkapaTokens.space25};
  }
`;
export const StyledSubHeading = styled.h2 `
  margin-top: 0;
  margin-bottom: ${SkapaTokens.space150};
  font-weight: normal;
`;
export const StyledCopy = styled.div `
  margin-bottom: ${props => (props.$isCompact ? SkapaTokens.space125 : SkapaTokens.space150)};
`;
export const StyledGuideHeading = styled.div `
  text-align: ${props => (props.$alignCenter ? 'center' : 'unset')};
  h2 {
    margin-top: ${props => (props.$isFirstGuide ? 0 : SkapaTokens.space300)};
    margin-bottom: ${SkapaTokens.space25};
  }
`;
export const StyledGuideSubHeading = styled.div `
  h3 {
    margin-top: 0;
    margin-bottom: ${SkapaTokens.space100};
    font-weight: normal;
  }
`;
export const StyledGuideContainer = styled.div `
  padding-bottom: ${props => (props.$isSidebarMode ? SkapaTokens.space550 : 0)};
`;
export const StyledLegend = styled.legend `
  height: 0;
  margin: 0;
  color: transparent;
  position: absolute;
`;
//# sourceMappingURL=styles.js.map